const RTAP_SELECTOR = '.rTapNumber174976, .rTapNumber175134';
const TEL_LINK_SELECTOR = 'a[href^="tel:"]';

function isInDisplayedTree(el: Element): boolean {
  // display:none ancestors → no client rects. opacity:0 / clipped nodes still count.
  return (el as HTMLElement).getClientRects().length > 0;
}

function readNumber(el: Element | null | undefined): string | undefined {
  const text = el?.textContent?.trim();
  return text || undefined;
}

/**
 * On mobile the desktop rTap span sits in `display:none` and is never replaced.
 * Prefer a displayed span so we do not keep syncing the CMS number from the hidden one.
 */
function getBestTelNumber(): string | undefined {
  const spans = Array.from(document.querySelectorAll(RTAP_SELECTOR));
  if (spans.length === 0) {
    return undefined;
  }

  for (const span of spans) {
    if (isInDisplayedTree(span)) {
      const number = readNumber(span);
      if (number) {
        return number;
      }
    }
  }

  return readNumber(spans[0]);
}

function applyTelNumber(telNumber: string): void {
  const next = `tel:${telNumber}`;
  document.querySelectorAll(TEL_LINK_SELECTOR).forEach((link) => {
    if (link.getAttribute('href') !== next) {
      link.setAttribute('href', next);
    }
  });
}

function syncTelHrefsFromRtap(): void {
  const telNumber = getBestTelNumber();
  if (telNumber) {
    applyTelNumber(telNumber);
  }
}

function numberFromMutationTarget(target: Node): string | undefined {
  const el =
    target.nodeType === Node.TEXT_NODE
      ? (target.parentElement as HTMLElement | null)
      : (target as HTMLElement);

  if (!el) {
    return undefined;
  }

  const span = el.closest(RTAP_SELECTOR) as HTMLElement | null;
  return readNumber(span);
}

/**
 * Keeps `tel:` hrefs in sync with Infinity/ResponseTap replacement.
 * Immediate via MutationObserver (replaces the old 3s poll).
 */
export function initTelephoneNumberSync(): void {
  syncTelHrefsFromRtap();

  const observeTargets = document.querySelectorAll(RTAP_SELECTOR);
  if (observeTargets.length === 0) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const telNumber = numberFromMutationTarget(mutation.target);
      if (telNumber) {
        applyTelNumber(telNumber);
        return;
      }
    }
    syncTelHrefsFromRtap();
  });

  observeTargets.forEach((el) => {
    observer.observe(el, {
      characterData: true,
      childList: true,
      subtree: true
    });
  });
}
